import { apiGetHistory } from "../services/authService";
import { useAuth } from "../context/AuthContext";
import { usePaginatedFetch } from "../hooks/usePaginatedFetch";
import { FetchError } from "../errors/FetchError";
import BattleHistory from "../components/BattleHistory";
import "../App.css";

export default function HistoryPage() {
  const { user, authLoading } = useAuth();
  const { items: history, hasMore, loading, loadingMore, error, loadMore, retry } = usePaginatedFetch(
    (offset, limit, signal) => apiGetHistory({ offset, limit, signal }),
    { key: user?.id ?? null, enabled: Boolean(user), pageSize: 10 }
  );

  const isLoading = authLoading || loading;

  return (
    <section className="arena-bg">
      <div className="page-heading">
        <h2 className="page-title">Battle History</h2>
        <p className="page-sub">Your recent battles</p>
      </div>
      {isLoading ? (
        <div className="battle-cards-grid">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="bpc-skeleton skeleton" />
          ))}
        </div>
      ) : !user ? (
        <div className="history-guest">
          <h3 className="history-guest-title">Track Your Battles</h3>
          <p className="history-guest-sub">
            Sign in to save your battle history and pick up where you left off.
          </p>
          <button
            className="fight-btn"
            style={{ maxWidth: 260 }}
            onClick={() => window.dispatchEvent(new CustomEvent("auth:open"))}
          >
            Sign In
          </button>
        </div>
      ) : error && history.length === 0 ? (
        <FetchError message="Couldn't load your battle history." onRetry={retry} />
      ) : (
        <BattleHistory
          history={history}
          hasMore={hasMore}
          loadingMore={loadingMore}
          onLoadMore={loadMore}
          loadMoreError={error}
        />
      )}
    </section>
  );
}
